import React, { useState } from 'react';
import { Card, Modal, Stack, Title } from 'library/ui';
import { Grid } from '@mui/material';
import { BusinessSlot } from 'models';
import { BusinessJobShiftSlot } from '../BusinessJob/components/BusinessJobShiftSlot';
import { ApplicantApprovalSummary } from './BusinessCalendar';
import { isAfter, isToday, isTomorrow, subHours } from 'date-fns';
import UnfilledShiftsWithApprovals from './UnfilledShiftsWithApprovals';
export default function UnfilledShifts({
    slots,
    title,
    refresh,
    approvals,
}: {
    slots: BusinessSlot[];
    title: string;
    refresh: () => void;
    approvals: ApplicantApprovalSummary[];
}) {
    const [viewShifts, setViewShifts] = useState(false);
    const unfilledShifts = slots.reduce((unfilledJobsWithSlots: { [key: string]: number }, slot: BusinessSlot) => {
        const job = slot.ongoing_request.id.toString();
        unfilledJobsWithSlots[job] = unfilledJobsWithSlots[job] || 0;
        unfilledJobsWithSlots[job] =
            slot.appointments.length === 0
                ? unfilledJobsWithSlots[job] + 1
                : unfilledJobsWithSlots[job] + slot.appointments.filter((appt) => appt.providers.length === 0).length;

        return unfilledJobsWithSlots;
    }, {});
    const date = new Date(slots[0].start_date);
    const isTodayOrTomorrow = (isToday(date) && isAfter(date, subHours(new Date(), 4))) || isTomorrow(date);
    const unfilledShiftsWithApprovals = Object.entries(unfilledShifts).filter(
        (x) =>
            isTodayOrTomorrow &&
            approvals.some((approval) => approval.job.toString() === x[0] && approval.applicants.length > 0),
    );
    const unfilledShiftsWithoutApprovals = Object.entries(unfilledShifts).filter(
        (x) =>
            !isTodayOrTomorrow ||
            !approvals.some((approval) => approval.job.toString() === x[0] && approval.applicants.length > 0),
    );
    const totalUnfilledWithoutApprovals = unfilledShiftsWithoutApprovals.reduce((acc, [, count]) => acc + count, 0);

    return (
        <Stack gap="sm" align="center">
            {unfilledShiftsWithApprovals.map(([jobId, count]) => (
                <UnfilledShiftsWithApprovals
                    key={jobId}
                    jobId={jobId}
                    count={count}
                    approvalsForJob={approvals.find(
                        (approval) => approval.job.toString() === jobId && approval.applicants.length > 0,
                    )}
                    onViewShifts={() => setViewShifts(true)}
                />
            ))}
            {totalUnfilledWithoutApprovals > 0 && (
                <Card onClick={() => setViewShifts(true)} interactive padding="xs" tone="error">
                    {totalUnfilledWithoutApprovals} unfilled shift
                    {totalUnfilledWithoutApprovals === 1 ? '' : 's'}
                </Card>
            )}
            {viewShifts && (
                <Modal onClose={() => setViewShifts(false)} width={720}>
                    <Stack gap="lg">
                        <Title size="h1">{`Unfilled shifts for ${title}`}</Title>
                        <Grid item container direction="row" style={{ gap: 20 }}>
                            {slots.map((slot) => (
                                <BusinessJobShiftSlot
                                    key={slot.id}
                                    slot={slot}
                                    job={slot.ongoing_request}
                                    getJob={refresh}
                                    md={slots.length === 1 ? 8 : 5}
                                    businessJobType={slot.ongoing_request.business_job_type}
                                />
                            ))}
                        </Grid>
                    </Stack>
                </Modal>
            )}
        </Stack>
    );
}
